import React from 'react';

import s from './main-template.module.scss';
import { BackwardButton, Button, Typography } from '../../atoms';
import { RouterSlilderTabs } from '../../../components';

interface MainTemplateProps {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  withSliderTabs?: boolean;
}

const LINKS = [
  {
    to: '/',
    title: 'Информация',
  },
  {
    to: '/teachers',
    title: 'Преподаватели',
  },
  {
    to: '/contacts',
    title: 'Контакты',
  },
];

export const MainTemplate: React.FC<MainTemplateProps> = ({
  header,
  children,
  footer,
  withSliderTabs,
}) => (
  <div className={s.main}>
    {header && <div className={s.header}>{header}</div>}
    {withSliderTabs && <RouterSlilderTabs links={LINKS} />}
    {children}
    {footer && <div className={s.footer}>{footer}</div>}
  </div>
);
